export default "__VITE_ASSET__DEQUxKcj__"